<template>
  <div>
    <div class="ui input"><input type="text" v-model="username" placeholder="CCS Username"></div>
    <div class="ui input"><input type="password" v-model="password" placeholder="Password"></div>
    <button class="ui primary button" @click="login">Login</button>
  </div>
</template>

<script>
  
export default {
  data() {
    return {
      username: '',
      password: ''
    };
  },
  methods: {
    login() {
      const thiz = this;
      // Send login request and handle authentication token
      fetch(this.$host+'/login', {
        method:'POST',
        mode: "cors",
        cache: 'no-cache',
        headers: {
          'Content-type':'application/json'
        },
        credentials:'include',
        body: JSON.stringify({username:this.username, password: this.password})
      }).then(res=>res.json()).then(res=>{
        console.log('login res', res);
        if (res.error) {
          console.log('application error login#27', res)
        }
        else {
          localStorage.setItem('admin', JSON.stringify(res.admin));
          localStorage.setItem('adminusername', res.admin.username);
          localStorage.setItem('adminname', res.admin.adminname);
          localStorage.setItem('adminid', res.admin.id);
          console.log('successful login');
          thiz.$router.push('/');
        }
      }).catch(err=>{
        console.log('system error login#33', err);
      });
      // Store token in local storage
    }
  }
};
</script>
